import { useNavigate } from 'react-router-dom';
import { SlidingTabs } from '@/components/ui';
import { useRequireB2CPermission } from '@/hooks';
import { ProfessionalSubpageHeader } from '../components/ProfessionalSubpageHeader';
import { Availability } from './Availabilities';
import { Unavailabilities } from './Unavailabilities';

const ProfessionalAgenda = () => {
	const navigate = useNavigate();
	const { isLoading, canManageAvailability } = useRequireB2CPermission();

	const tabs = [
		{
			id: 'availability',
			label: 'Disponibilidade',
			children: <Availability />,
		},
		{
			id: 'unavailability',
			label: 'Indisponibilidade',
			children: <Unavailabilities />,
		},
	];

	if (isLoading || !canManageAvailability) {
		return null;
	}

	return (
		<div className="flex min-h-full w-full justify-center px-4 py-4 md:px-6 md:py-5">
			<section className="w-full max-w-[1340px] animate-fade-in space-y-5">
				<ProfessionalSubpageHeader
					title="Meus horários"
					breadcrumb={['HORÁRIOS', 'CONFIGURAÇÃO']}
					onBack={() => navigate('/profissional/home')}
				/>
				<SlidingTabs tabs={tabs} defaultActiveTab="availability" />
			</section>
		</div>
	);
};

export { ProfessionalAgenda };
